<div class="d-flex" style="border-radius: 10px;background-color:rgba({{hexToRgb(data?.pacc?.course?.color)?.r}}, {{hexToRgb(data?.pacc?.course?.color)?.g}}, {{hexToRgb(data?.pacc?.course?.color)?.b}}, .3); width: 100%; height: 6rem;">
    <div class="w-25  d-flex justify-content-around flex-column" style="border-radius: 10px;height: 6rem;background-color:rgba({{hexToRgb(data?.pacc?.course?.color)?.r}}, {{hexToRgb(data?.pacc?.course?.color)?.g}}, {{hexToRgb(data?.pacc?.course?.color)?.b}}, .7); ">
        <span>{{data?.start_time}}</span>
        <span>{{data?.end_time}}</span>
    </div>
    <div class="w-75 text-start p-1" style="height: 6rem;">
        <h6><strong>{{data?.name}}</strong> <span class="float-end">{{data?.programming_date | date:'dd-MM-yyyy'}}</span></h6>
        <p>{{data?.course?.name}}</p>
        <!-- <p>Salles 105</p> -->
    </div>
</div>